import { Component, Input } from '@angular/core';
import { IGuideLineSuggestion } from '../suggestion-sidebar.component';
import { GlobalService } from 'app/global/global.service';
import { PlaybookGuidelineStatusEnum } from 'app/main/pages/legal-hub/playbooks/playbook-list/plyabbok-guideline-run-tile/playbook-guideline-run-tile.component';

@Component({
  selector: 'app-lh-suggestion-content',
  templateUrl: './lh-suggestion-content.component.html',
  styleUrl: './lh-suggestion-content.component.scss'
})
export class LhSuggestionContentComponent {
    @Input({required: true}) data:IGuideLineSuggestion;

    constructor(private globalService:GlobalService) { }

    get reason(){
        return this.globalService.sanitizeContent(this.data?.reason ?? '') ;
    }

    get reference(){
        return this.globalService.sanitizeContent(this.data?.reference ?? '') ;
    }

    get suggestion(){
        return this.globalService.sanitizeContent(this.data?.suggestion ?? '') ;
    }


    protected readonly PlaybookGuidelineStatusEnum = PlaybookGuidelineStatusEnum;
}
